import EsqueciSenhaForm from "./EsqueciSenhaForm";

export default EsqueciSenhaForm;
